module.exports = __webpack_public_path__ + "static/media/legal.b49fd29b.svg";